import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import DistrictTable from './table/js/districtTable';
import DistrictCreate from './create/js/districtCreate';
import PropTypes from 'prop-types';

function DistrictManagement() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="eduss-district-management" style={{ padding: '20px' }}>
      <DistrictTable 
        onCreateDistrict={() => setShowCreateModal(true)} 
        reloadKey={reloadKey}
      />

      {/* Create District Modal */}
      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal large eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New District</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <DistrictCreate
                onClose={() => setShowCreateModal(false)}
                onSubmit={() => { setReloadKey(p => p + 1); setShowCreateModal(false); }}
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

DistrictManagement.propTypes = {
  initialTab: PropTypes.string,
};

export default DistrictManagement;
